import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { NetworkPopUpType } from '../../network.pop-up.factory';
import { GzMalwareScanWebComponent } from './component/GzMalwareScanWebComponent';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import {
  MALWARE_SCAN_ID,
  MalwareScan,
  MalwareScanAction,
  MalwareScanArchives,
  MalwareScanArchivesSettings,
  MalwareScanCpuUsageControl,
  MalwareScanCredentials,
  MalwareScanForm,
  MalwareScanMiscellaneous,
  MalwareScanSpecifics,
} from './component/types';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { translateFn } from '../../../../utils/translator.helper';
import { MalwareScanHelper } from './component/helpers/malware.scan.helper';

export class MalwareScanPopUp extends NetworkBasePopUp<GzMalwareScanWebComponent> {
  private type = NetworkPopUpType.MALWARE_SCAN;
  protected title = translateFn('Malware scan');
  protected transformToTaskTarget = true;
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpContent = new GzMalwareScanWebComponent();
    if (this.shouldShowNetworkType()) {
      this.popUpContent.shouldShowNetworkType = true;
    }
  }

  private shouldShowNetworkType(): boolean {
    if (this.data?.targets?.length !== 1) {
      return false;
    }

    const protectedEntityData = this.data.targets[0] as ProtectedEntity;
    const appId = protectedEntityData.specifics.appId;

    if (!appId) {
      return false;
    }

    const acceptedAppIds = [
      Constants.Endpoints.APP_IDS.APPID_EP_CLIENT,
      Constants.Endpoints.APP_IDS.APPID_UNIFIED_CLIENT,
      Constants.Endpoints.APP_IDS.APPID_SCANDINAVIA_CLIENT,
    ];
    return acceptedAppIds.includes(appId);
  }

  protected async handleConfirmButtonClicked() {
    const formValue = this.popUpContent.getFormValue();
    const payload = MalwareScanHelper.transformFormValueToConsoleRequestParams(formValue, this.data.targets);

    await this.createTask<MalwareScanSpecifics>(payload);
  }
}
